<template>
  <PasswordVault :client-id="clientId" :hideTitle="true" />
</template>

<script>
import { mapActions } from "vuex";
import PasswordVault from "src/views/Pages/PasswordVault";
export default {
  props: {
    clientId: Number,
  },

  components: {
    PasswordVault,
  },

  methods: {
    ...mapActions({
      getAll: "passwordVault/getAll",
    }),

    async refresh() {
      await this.getAll();
    },
  },

};
</script>